import { LABEL_STATUT_AVOIR, LABEL_TYPE_AVOIR } from '../../lib/format';

interface Props {
  statut: string;
}

const colorMap: Record<string, string> = {
  Emis: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  Utilise: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  Rembourse: 'bg-blue-500/15 text-blue-300 border-blue-500/30',
  Annule: 'bg-slate-500/15 text-slate-300 border-slate-500/30',
};

export function StatutAvoirBadge({ statut }: Props): JSX.Element {
  const color = colorMap[statut] ?? 'bg-slate-500/15 text-slate-300 border-slate-500/30';
  const label = LABEL_STATUT_AVOIR[statut] ?? statut;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md border ${color}`}
    >
      {label}
    </span>
  );
}

export function TypeAvoirBadge({ type }: { type: string }): JSX.Element {
  const color =
    type === 'Credit'
      ? 'bg-blue-500/15 text-blue-300 border-blue-500/30'
      : 'bg-rose-500/15 text-rose-300 border-rose-500/30';
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md border ${color}`}
    >
      {LABEL_TYPE_AVOIR[type] ?? type}
    </span>
  );
}
